import React from 'react';
import { Link } from 'react-router-dom';
import Users from '../users/Users';
import { ConnectedUserContext } from '../connectedUser-context';

// Flash au disconnect
// 1. Masquer le flash avec un état isLoggingOut ✅ (Meilleure option rapide)
// 2. Déconnecter via une requête API avant la redirection ✅ (Évite le flash complètement)
// 3. Utiliser federated: true pour une déconnexion propre ✅ (Si l’utilisateur se connecte avec Google/Facebook aussi)


class Sidebar extends React.Component {
	static contextType = ConnectedUserContext;

	sidebarClick(e) {
		document.body.classList.toggle('sidebar-mobile-show');
	}

	// AUTH0 UNIVERSAL LOGIN
  handleLogin = () => {
		this.props.auth0?.loginWithRedirect?.({
		  redirectUri: window.location.origin
		});

  };

	handleLogout = async () => {
	  await this.props.auth0?.logout?.({
	    returnTo: window.location.origin,
	    federated: true,
	  });

	  window.location.href = window.location.origin;
	  // ça semble déclencher un flash, voir solutions potentielles dans chatGPT
	};

	dispConnect() {
		const { connectedUser } = this.context;
		if (!connectedUser) {
			return (
				<li className="nav-item">
					<a className="nav-link" onClick={this.handleLogin}>
						<i className="icon-login"></i> Se connecter
					</a>
				</li>
			);
		}
	}

	dispConnectedProfile() {
		//console.log('SIDEBAR: dispConnectedProfile')
    //console.log('connectedUser:', connectedUser);
		const { connectedUser } = this.context;
		if (connectedUser) {
  		const userName = connectedUser.user?.name || connectedUser.name || '';
  		const picture = connectedUser.user?.picture;

			return (
				<div>
				<li className="sidebar-special-connect"> Vous êtes connecté ... </li><br/>
				<li className="sidebar-special-item">
					{picture && <img className="img-sidebar-token" src={picture} alt="profil" />}
					<span>&nbsp;&nbsp; {userName}</span>
				</li>
				<li className="nav-item">
					<Link to='/userAccount' className="nav-link">
						<i className="icon-user"></i> Votre Compte
					</Link>
				</li>
				</div>
			);
		}
	}

	dispDisconnect() {
		const { connectedUser } = this.context;
		if (connectedUser) {
			return (
				<li className="nav-item">
					<Link to='/' className="nav-link" onClick={this.handleLogout}>
						<i className="icon-logout"></i> Se déconnecter
					</Link>
				</li>
			);
		}
	}

	dispAdmin() {
		const { connectedUser } = this.context;
    // console.log("SIDEBAR - connectedUser", connectedUser)

		if (connectedUser) {
    	if (connectedUser.isAdmin) {
				return (
					<div>	
						<li className="nav-title text-center">
							<span>ADMIN</span>
						</li>
						<li className="nav-item">
							<Link to='/admsafe' className="nav-link">
							<i className="icon-wrench"></i> Admin
						</Link>
						</li>

						{connectedUser.isQvneaMaster && (
							<li className="nav-item">
								<Link to='/qvnea/qvnea-books' className="nav-link">
									<i className="icon-wrench"></i> Qvnea Books
								</Link>
							</li>
						)}
					</div>
				);
			}
		}
	}

	dispStateloViesAd() {
		return (
			<div className="text-center">
				<a href="http://statelovies.com" target="_blank" className="text-center whiteLink">
					<img className="img-fluid" src="/img/statelovies.png" alt="statelo-tour" width="140"/>
				</a>
			</div>
		)
	}

	dispPredatorTourAd() {
		return (
			<div className="text-center">
				<Link to="/qvnea/predator-tour" className="text-center whiteLink">
					<img className="img-fluid" src="/img/predator-tour-02a.png" alt="predator-tour" width="170"/>
				</Link>
			</div>
		)
	}


	render() {
		const { connectedUser } = this.context;
		//console.log("SIDEBAR - render: connectedUser: ", this.context.connectedUser);

		return (
			<div className="sidebar no-print row-margin-bottom-200">
			<nav className="sidebar-nav">
				<ul className="nav" onClick={this.sidebarClick}>
					<li className="nav-title text-center">
						<span>STATELO</span>
					</li>
					<li className="nav-item">
						<Link to='/' className="nav-link">
							<i className="icon-home"></i> Accueil
						</Link>
					</li>
					<li className="nav-item">
						<Link to='/stats' className="nav-link">
							<i className="icon-trophy"></i> Statistiques
						</Link>
					</li>
					<li className="nav-item">
						<Link to='/players' className="nav-link">
							<i className="icon-people"></i> Joueurs
						</Link>
					</li>
					<li className="nav-title text-center">
						<span>TABLEAU DE BORD</span>
					</li>
					<li className="nav-item">
						<Link to='/tableau-de-bord' className="nav-link">
							<i className="icon-bulb"></i> Aperçu général
						</Link>
						<Link to='/playerDashboard' className="nav-link">
							<i className="icon-speedometer"></i> Mon Tableau de Bord
						</Link>
					</li>

					<li className="nav-title text-center">
						<span>CONNEXION</span>
					</li>

					{this.dispConnect()}
					{this.dispConnectedProfile()}
					{this.dispDisconnect()}
					{this.dispAdmin()}
					<br/>
					{this.dispStateloViesAd()}
					<br/>
					{/*this.dispPredatorTourAd()*/}
					{/*<br/>*/}
					<li className="nav-item"> <span>&nbsp;</span> </li>
					<li className="nav-item"> <span>&nbsp;</span> </li>
				</ul>
			</nav>
			</div>
		)
	}

}

export default Sidebar;